import { render, staticRenderFns } from "./discovery.vue?vue&type=template&id=a8e4f808&"
import script from "./discovery.vue?vue&type=script&lang=js&"
export * from "./discovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports